import { render } from "./DiseaseSurveillance.vue?vue&type=template&id=28d4440a&scoped=true"
import script from "./DiseaseSurveillance.vue?vue&type=script&lang=js"
export * from "./DiseaseSurveillance.vue?vue&type=script&lang=js"

import "./DiseaseSurveillance.vue?vue&type=style&index=0&id=28d4440a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d4440a"]])

export default __exports__